import getTextAndTranslateFromError from '@widesk-core/tools/getTextAndTranslateFromError';

export default function getErrorMessage(err: any, t: (key: string) => string): string {
	const statusCode: number | undefined = err?.connectorError?.request?.status;

	if (statusCode) {
		const key = `app.errors.http.${statusCode}`;
		const translated = t(key);
		if (translated !== key) {
			return translated;
		}
	}

	return getTextAndTranslateFromError(err) ?? '';
}
